/**
 *  Action Constants
 */
import { Dispatch, ExtraArgs, GetState } from '../../types'
import { ApplicationData, ReportsApplication } from './model'
import MonitoringLocalStorageManager from '../../util/storage/MonitoringLocalStorageManager'
import { ReportsService } from './util/ReportsService'
import { ARMApplication } from '../../remote-api/models'
import ApplicationService from '../../services/core/ApplicationService'

export const Loading = 'Monitoring/Reports/Loading'
export const ChangeApplications = 'Monitoring/Reports/ChangeApplications'
export const ChangeApplicationsData = 'Monitoring/Reports/ChangeApplicationsData'
export const ChangeSelectedType = 'Monitoring/Reports/ChangeSelectedType'
export const ChangeDateRange = 'Monitoring/Reports/ChangeDateRange'
export const ChangeApplicationsARM = 'Monitoring/Reports/ChangeApplicationsARM'

/**
 *  Action Type
 */
export type LoadingAction = {
  type: 'Monitoring/Reports/Loading'
}

export type ChangeApplicationsAction = {
  type: 'Monitoring/Reports/ChangeApplications'
  payload: {
    data: ReportsApplication[]
  }
}

export type ChangeApplicationsDataAction = {
  type: 'Monitoring/Reports/ChangeApplicationsData'
  payload: {
    data: ApplicationData[]
  }
}

export type ChangeSelectedTypeAction = {
  type: 'Monitoring/Reports/ChangeSelectedType'
  payload: {
    selectedType: string
  }
}

export type ChangeDateRangeAction = {
  type: 'Monitoring/Reports/ChangeDateRange'
  payload: {
    dateRange: string
  }
}

export type ChangeApplicationsARMAction = {
  type: 'Monitoring/Reports/ChangeApplicationsARM'
  payload: {
    data: ARMApplication[]
  }
}

/**
 *  Action Creators
 */
export const initializeLoadingAction = (): LoadingAction => ({
  type: Loading
})

export const initializeLoading = () => (dispatch: Dispatch) => {
  dispatch(initializeLoadingAction())
}

export const changeApplications = (data: ReportsApplication[]): ChangeApplicationsAction => ({
  type: ChangeApplications,
  payload: {data}
});

export const changeApplicationsData = (data: ApplicationData[]): ChangeApplicationsDataAction => ({
  type: ChangeApplicationsData,
  payload: {data}
})

export const changeApplicationsARM = (data: ARMApplication[]): ChangeApplicationsARMAction => ({
  type: ChangeApplicationsARM,
  payload: { data }
})

export const fetchApplications = (businessGroup: string, environment: string) => (dispatch: Dispatch, getState: GetState, { api }: ExtraArgs) => {
  return api.ui(getState).fetchApplicationsForReports(businessGroup, environment).then((data: any) => {
    dispatch(changeApplications(data.applications))
  })
}

export const fetchApplicationsARM = (businessGroup: string, environment: string) => (dispatch: Dispatch, getState: GetState, { api }: ExtraArgs) => {
  const orgId = businessGroup
  const appService = new ApplicationService(orgId, api.arm(getState))
  return appService.getApplications(environment).then(response => {
    dispatch(changeApplicationsARM(response.data))
  }).catch(() => dispatch(changeApplicationsARM([])))
}

export const fetchApplicationsData = (businessGroup: string, env: string, reportsType: string, dateRange: any) =>
  (dispatch: Dispatch, getState: GetState, {api}: ExtraArgs) => {
    dispatch(initializeLoading())
    
    const newLS = {selectedBusinessGroup: businessGroup, selectedEnvironment: env, selectedType: reportsType, from: dateRange.from, to: dateRange.to}
    MonitoringLocalStorageManager.put('reports', newLS)
    
    return api.ui(getState).fetchApplicationsData(businessGroup, env, reportsType, dateRange)
      .then((data: {applicationData: ApplicationData[], type: string}) => {
        const reportApplications = getState().monitoring.reports.applications
        const resourceApplications = getState().monitoring.resources.applications.data
        const appData = ReportsService.filterApplicationData(data, reportApplications, resourceApplications)
        dispatch(changeApplicationsData(appData))
      }).catch(() => dispatch(changeApplicationsData([])))
  }

export const changeSelectedTypeAction = (selectedType: string): ChangeSelectedTypeAction => ({
  type: ChangeSelectedType,
  payload: {selectedType}
})

export const changeSelectedType = (selectedType: string) => (dispatch: Dispatch) => {
  dispatch(changeSelectedTypeAction(selectedType))
}

export const changeDateRangeAction = (dateRange: string): ChangeDateRangeAction => ({
  type: ChangeDateRange,
  payload: {dateRange}
})

export const changeDateRange = (dateRange: any) => (dispatch: Dispatch) => {
  dispatch(changeDateRangeAction(`${dateRange.from} - ${dateRange.to}`))
}

export type ReportsActions =
  | LoadingAction
  | ChangeApplicationsAction
  | ChangeApplicationsDataAction
  | ChangeSelectedTypeAction
  | ChangeDateRangeAction
  | ChangeApplicationsARMAction
